/* global axios */
import ApiClient from './ApiClient';

// Eltafouk: WhatsApp template usage report (per template / delivery status /
// number / agent / day / hour). Accepts an ISO date range (since/until,
// Africa/Cairo). Identifies templates by the technical template_params marker,
// not by message text.
class TemplateUsageReports extends ApiClient {
  constructor() {
    super('template_usage_reports', { accountScoped: true });
  }

  fetch({ since, until } = {}) {
    const params = {};
    if (since) params.since = since;
    if (until) params.until = until;
    return axios.get(this.url, { params });
  }
}

export default new TemplateUsageReports();
